import { useEffect, useState } from "react";
import { UpsellGroup } from "types/upsellGroup";
import { useArticleStore } from "store/articleStore";

/**
 * Hook used to idenfity what upsell group shoule be visible to user,
 * and (not yet supported from BE) step to the next group if any.
 */
export function useUpsellGroups(isOpen: boolean) {
	const { upsellGroups } = useArticleStore();
	const [upsellGroup, setUpsellGroup] = useState<UpsellGroup | undefined>(
		upsellGroups ? upsellGroups[0] : undefined,
	);

	const isLast = (): boolean => {
		if (!upsellGroups || !upsellGroup) return true;

		const currentIndex = upsellGroups.indexOf(upsellGroup);
		const lastIndex = upsellGroups.length - 1;
		return currentIndex === lastIndex;
	};

	const onNext = () => {
		if (isLast() || !upsellGroups || !upsellGroup) return;

		const nextIndex = upsellGroups.indexOf(upsellGroup) + 1;
		setUpsellGroup(upsellGroups[nextIndex]);
	};

	useEffect(() => {
		if (isOpen && upsellGroups) {
			setUpsellGroup(upsellGroups[0]);
		}
	}, [isOpen, upsellGroups]);

	return { upsellGroup, onNext, isLast };
}
